/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EventsCarsFilter = {
            /**
            * `true` - select only acknowledged events (do not require acknowledgement), `false` - select only unacknowledged events
            */
        acknowledged?: boolean;
            /**
            * `true` - select only events with backward intersected line. `false` - select only events intersected line in one direction.
            */
        backward_line_crossing?: boolean;
            /**
            * Select events where `features.body.name` takes one of these values
            */
        body?: Array<'cab' | 'convertible' | 'coupe' | 'crossover' | 'limousine' | 'minibus' | 'minivan' | 'sedan' | 'suv' | 'wagon'>;
            /**
            * Select events where `features.body.confidence` is **greater than or equal** to this value
            */
        body_score_gte?: number;
            /**
            * Select events where `features.body.confidence` is **less than or equal** to this value
            */
        body_score_lte?: number;
            /**
            * Select objects where `bs_type` takes one of these values
            */
        bs_type?: 'overall' | 'realtime';
            /**
            * Get events from these `camera groups`
            */
        camera_groups?: Array<number>;
            /**
            * Get events from these `cameras`
            */
        cameras?: Array<number>;
            /**
            * Select events related to these `cases`
            */
        case_in?: Array<number>;
            /**
            * Select events where `features.category.confidence` is **greater than or equal** to this value
            */
        category_score_gte?: number;
            /**
            * Select events where `features.category.confidence` is **less than or equal** to this value
            */
        category_score_lte?: number;
            /**
            * Select events where `features.category.name` takes one of these values
            */
        category_type?: Array<'A' | 'B' | 'BE' | 'C' | 'CE' | 'D' | 'DE' | 'other' | 'unknown'>;
            /**
            * Select events where `features.color.name` takes one of these values
            */
        color?: Array<'beige' | 'black' | 'blue' | 'brown' | 'cyan' | 'gold' | 'green' | 'grey' | 'orange' | 'pink' | 'purple' | 'red' | 'silver' | 'violet' | 'white' | 'yellow'>;
            /**
            * Select events where `features.color.confidence` is **greater than or equal** to this value
            */
        color_score_gte?: number;
            /**
            * Select events where `features.color.confidence` is **less than or equal** to this value
            */
        color_score_lte?: number;
            /**
            * Select objects with `created_date` **greater than or equal** to this value
            */
        created_date_gte?: string;
            /**
            * Select objects with created in last N days
            */
        created_date_last_n_days?: number;
            /**
            * Select objects with `created_date` **less than or equal** to this value
            */
        created_date_lte?: string;
            /**
            * Select objects with created in last Nth week (including Sunday and Saturday)
            */
        created_date_nth_full_week?: number;
            /**
            * Select objects with created in last Nth week (only working days, i.e. excluding Sunday and Saturday)
            */
        created_date_nth_work_week?: number;
            /**
            * Select events that matched this episode
            */
        episode?: number;
            /**
            * Select events that created by external detectors
            */
        external_detector?: boolean;
            /**
            * `true` - select only events relates to case. `false` - select only events without case.
            */
        has_case?: boolean;
            /**
            * Exact filter by ID
            */
        id?: number;
            /**
            * Select objects with `id` **greater than or equal** to this value
            */
        id_gte?: number;
            /**
            * Select objects with provided ids
            */
        id_in?: Array<string>;
            /**
            * Select objects with `id` **less than or equal** to this value
            */
        id_lte?: number;
            /**
            * Select events where `features.license_plate_country.name` takes one of these values
            */
        license_plate_country?: Array<'AE' | 'AM' | 'AR' | 'AZ' | 'BR' | 'BY' | 'CZ' | 'EST' | 'FIN' | 'GE' | 'IN' | 'KG' | 'KZ' | 'LT' | 'LV' | 'MD' | 'MX' | 'PK' | 'RU' | 'SA' | 'SRB' | 'TH' | 'TJ' | 'TM' | 'UA' | 'UZ' | 'VN' | 'unknown'>;
            /**
            * Select events where `features.license_plate_country.confidence` is **greater than or equal** to this value
            */
        license_plate_country_score_gte?: number;
            /**
            * Select events where `features.license_plate_country.confidence` is **less than or equal** to this value
            */
        license_plate_country_score_lte?: number;
            /**
            * Select events where `features.license_plate_number_color` takes one of these values
            */
        license_plate_number_color?: Array<string>;
            /**
            * Select events where `features.license_plate_number_color.confidence` is **greater than or equal** to this value
            */
        license_plate_number_color_score_gte?: number;
            /**
            * Select events where `features.license_plate_number_color.confidence` is **less than or equal** to this value
            */
        license_plate_number_color_score_lte?: number;
            /**
            * Select events where `features.model.license_plate_number` contains provided string(case insensitive)
            */
        license_plate_number_contains?: string;
            /**
            * Select events where `features.license_plate_number.confidence` is **greater than or equal** to this value
            */
        license_plate_number_score_gte?: number;
            /**
            * Select events where `features.license_plate_number.confidence` is **less than or equal** to this value
            */
        license_plate_number_score_lte?: number;
            /**
            * Select events where `features.license_plate_region.name` takes one of these values
            */
        license_plate_region?: Array<string>;
            /**
            * Select events where `features.license_plate_region.confidence` is **greater than or equal** to this value
            */
        license_plate_region_score_gte?: number;
            /**
            * Select events where `features.license_plate_region.confidence` is **less than or equal** to this value
            */
        license_plate_region_score_lte?: number;
            /**
            * Number of results to return per page.
            */
        limit?: number;
            /**
            * Select events that intersect line in this direction
            */
        line_crossing_direction?: 'AB' | 'BA';
            /**
            * Select events that intersects with this lines
            */
        line?: Array<number>;
            /**
            * Select events with faces similar to: (`detection:<detection id>`, `{face, body or car}object:<object id>`, `{face, body or car}event:<event id>`, `{face, body or car}cluster:<cluster id>` or `caseparticipant:<caseparticipant id>`). You can pass several search sources to search for. Pagination works if there is only one face to search for and if the sorting order is id. In all other cases, only the first page of results is returned
            */
        looks_like?: string;
            /**
            * Select events where `features.make.name` takes one of these values
            */
        make?: Array<'ac' | 'acura' | 'adler' | 'alfa_romeo' | 'alpina' | 'am_general' | 'amc' | 'aro' | 'asia' | 'aston_martin' | 'audi' | 'austin' | 'austin_healey' | 'avtokam' | 'baic' | 'bajaj' | 'bentley' | 'blakely' | 'bmw' | 'borgward' | 'bradley' | 'brilliance' | 'bugatti' | 'buick' | 'bus' | 'byd' | 'cadillac' | 'can_am' | 'chana' | 'changan' | 'changfeng' | 'changhe' | 'chery' | 'chevrolet' | 'chrysler' | 'citroen' | 'dacia' | 'dadi' | 'daewoo' | 'daihatsu' | 'daimler' | 'dallara' | 'datsun' | 'derways' | 'dkw' | 'dodge' | 'dongfeng' | 'doninvest' | 'ds' | 'dw_hower' | 'eagle' | 'excalibur' | 'faw' | 'ferrari' | 'fiat' | 'fisker' | 'ford' | 'foton' | 'gaz' | 'geely' | 'genesis' | 'geo' | 'gmc' | 'great_wall' | 'hafei' | 'haima' | 'hanomag' | 'haval' | 'hawtai' | 'holden' | 'honda' | 'horch' | 'huanghai' | 'hudson' | 'hummer' | 'hyundai' | 'ig' | 'infiniti' | 'international' | 'iran_khodro' | 'isuzu' | 'jac' | 'jaguar' | 'jeep' | 'jinbei' | 'jmc' | 'kamaz' | 'kia' | 'lamborghini' | 'lancia' | 'land_rover' | 'landwind' | 'lexus' | 'lifan' | 'lincoln' | 'lotus' | 'luaz' | 'luxgen' | 'mahindra' | 'maruti' | 'maserati' | 'maybach' | 'mazda' | 'mclaren' | 'mercedes' | 'mercury' | 'metrocab' | 'mg' | 'mini' | 'mitsubishi' | 'mitsuoka' | 'morgan' | 'morris' | 'moscvich' | 'nash' | 'nissan' | 'oldsmobile' | 'opel' | 'packard' | 'peugeot' | 'plymouth' | 'polaris' | 'pontiac' | 'porsche' | 'proton' | 'puch' | 'ram' | 'rambler' | 'ravon' | 'renault' | 'rimac' | 'rolls_royce' | 'rover' | 'saab' | 'samsung' | 'saturn' | 'scion' | 'seat' | 'shanghai_maple' | 'shuanghuan' | 'simca' | 'skoda' | 'smart' | 'smz' | 'spyker' | 'ssang_yong' | 'steyr' | 'studebaker' | 'subaru' | 'sunbeam' | 'suzuki' | 'tagaz' | 'talbot' | 'tata' | 'tatra' | 'tesla' | 'think' | 'tianma' | 'tianye' | 'toyota' | 'trabant' | 'triumph' | 'uaz' | 'vauxhall' | 'vaz' | 'volkswagen' | 'volvo' | 'vortex' | 'wanderer' | 'wartburg' | 'willis' | 'willys' | 'xinkai' | 'zaz' | 'zenvo' | 'zil' | 'zis' | 'zotye' | 'zx'>;
            /**
            * Select events where `features.make.confidence` is **greater than or equal** to this value
            */
        make_score_gte?: number;
            /**
            * Select events where `features.make.confidence` is **less than or equal** to this value
            */
        make_score_lte?: number;
            /**
            * Select events that matched this card
            */
        matched_card?: number;
            /**
            * Select events that match a card included in these watch lists
            */
        matched_lists?: Array<number>;
            /**
            * Select events where `features.model.name` contains provided string(case insensitive)
            */
        model?: Array<string>;
            /**
            * Select events where `features.model.confidence` is **greater than or equal** to this value
            */
        model_score_gte?: number;
            /**
            * Select events where `features.model.confidence` is **less than or equal** to this value
            */
        model_score_lte?: number;
            /**
            * `true` - select only events without matches. `false` - select events only with matches.
            */
        no_match?: boolean;
            /**
            * Which field to use for ordering. Available values: id, -id. Available values for looks_like: -confidence, -looks_like_confidence, id, -id, confidence and looks_like_confidence ordering are equivalents
            */
        ordering?: string;
            /**
            * Select events where `features.orientation.name` takes one of these values
            */
        orientation?: Array<'back' | 'front' | 'side'>;
            /**
            * Select events where `features.orientation.confidence` is **greater than or equal** to this value
            */
        orientation_score_gte?: number;
            /**
            * Select events where `features.orientation.confidence` is **less than or equal** to this value
            */
        orientation_score_lte?: number;
            /**
            * Pagination cursor value.
            */
        page?: string;
            /**
            * Select events where `features.special_vehicle_type.name` contains provided string(case insensitive)
            */
        special_vehicle_type?: Array<'ambulance' | 'car_sharing' | 'gas_service' | 'military' | 'not_special' | 'other_special' | 'police' | 'rescue_service' | 'road_service' | 'route_transport' | 'taxi'>;
            /**
            * Select events where `features.special_vehicle_type.confidence` is **greater than or equal** to this value
            */
        special_vehicle_type_score_gte?: number;
            /**
            * Select events where `features.special_vehicle_type.confidence` is **less than or equal** to this value
            */
        special_vehicle_type_score_lte?: number;
            /**
            * Similarity threshold for `looks_like`
            */
        threshold?: number;
            /**
            * Get events from these video archives
            */
        video_archive?: Array<number>;
            /**
            * Select events where `features.weight_type.name` takes one of these values
            */
        weight_type?: Array<'B_heavy' | 'B_light' | 'C_heavy' | 'C_light' | 'D_light' | 'D_long' | 'other'>;
            /**
            * Select events where `features.weight_type.confidence` is **greater than or equal** to this value
            */
        weight_type_score_gte?: number;
            /**
            * Select events where `features.weight_type.confidence` is **less than or equal** to this value
            */
        weight_type_score_lte?: number;
}
export const EmptyEventsCarsFilter: EventsCarsFilter = {
        acknowledged: undefined,
        backward_line_crossing: undefined,
        body: [],
        body_score_gte: undefined,
        body_score_lte: undefined,
        bs_type: undefined,
        camera_groups: [],
        cameras: [],
        case_in: [],
        category_score_gte: undefined,
        category_score_lte: undefined,
        category_type: [],
        color: [],
        color_score_gte: undefined,
        color_score_lte: undefined,
        created_date_gte: undefined,
        created_date_last_n_days: undefined,
        created_date_lte: undefined,
        created_date_nth_full_week: undefined,
        created_date_nth_work_week: undefined,
        episode: undefined,
        external_detector: undefined,
        has_case: undefined,
        id: undefined,
        id_gte: undefined,
        id_in: [],
        id_lte: undefined,
        license_plate_country: [],
        license_plate_country_score_gte: undefined,
        license_plate_country_score_lte: undefined,
        license_plate_number_color: [],
        license_plate_number_color_score_gte: undefined,
        license_plate_number_color_score_lte: undefined,
        license_plate_number_contains: '',
        license_plate_number_score_gte: undefined,
        license_plate_number_score_lte: undefined,
        license_plate_region: [],
        license_plate_region_score_gte: undefined,
        license_plate_region_score_lte: undefined,
        limit: 20,
        line_crossing_direction: undefined,
        line: [],
        looks_like: undefined,
        make: [],
        make_score_gte: undefined,
        make_score_lte: undefined,
        matched_card: undefined,
        matched_lists: [],
        model: [],
        model_score_gte: undefined,
        model_score_lte: undefined,
        no_match: undefined,
        ordering: undefined,
        orientation: [],
        orientation_score_gte: undefined,
        orientation_score_lte: undefined,
        page: undefined,
        special_vehicle_type: [],
        special_vehicle_type_score_gte: undefined,
        special_vehicle_type_score_lte: undefined,
        threshold: undefined,
        video_archive: [],
        weight_type: [],
        weight_type_score_gte: undefined,
        weight_type_score_lte: undefined,
}
